module.exports = __webpack_public_path__ + "img/link.67e0e241.svg";